import { Fragment } from 'preact';
import PropTypes from 'prop-types';
import PrimaryNavigation from './components/PrimaryNavigation';
import SecondaryNavigation from './components/SecondaryNavigation';
import useNavContent from './hooks/use-nav-content';
import { showSecondaryNav } from './utils';
import './styles.scss';
import { VENUE_BUTTONS } from './config';

const Navigation = ({ contentId, apiHost, alternateNavbarTheme }) => {
  const data = useNavContent(contentId, apiHost);
  const navbarClassName = alternateNavbarTheme ? 'NavbarWrapper alternate' : 'NavbarWrapper';

  return (
    <Fragment>
      <div className={navbarClassName}>
        <PrimaryNavigation {...{ data }} venues={VENUE_BUTTONS} />
        {showSecondaryNav(data) && (<SecondaryNavigation {...data} venues={VENUE_BUTTONS} />)}
      </div>
    </Fragment>
  );
};

export default Navigation;

Navigation.defaultProps = {
  alternateNavbarTheme: false,
};

Navigation.propTypes = {
  contentId: PropTypes.string.isRequired,
  apiHost: PropTypes.string.isRequired,
  alternateNavbarTheme: PropTypes.bool,
};
